<script setup lang="ts"></script>

<template>
  <div class="wait-overlay">
    <div class="loader">
      <h1>Trwa przesyłanie formularza</h1>
      <div class="spinner"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.wait-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $black-200;
  opacity: 0.7;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  color: $white-100;
  font-family: Arial, sans-serif;
  font-size: 24px;

  .loader {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h1 {
      margin-bottom: 20px;
      font-size: 28px;
      font-weight: bold;
    }

    .spinner {
      border: 4px solid rgb(255 255 255 / 30%);
      border-radius: 50%;
      border-top: 4px solid $white-100;
      width: 50px;
      height: 50px;
      animation: spin 1s linear infinite;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
